import React from 'react';
import I18N from '@leverege/i18n';
import { Text, Flex, Label, Button, Content } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import DeviceInput from './DeviceInput';
import DeviceSearch from './DeviceSearch';
import Scan from '../../views/pairing/Scan';
import S from './PairKeysToVehicle.css';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('recovr.actions.pairKeys.PairKeysDialog');
export default function PairKeysDialog(props) {
  const {
    onClick,
    onDeleteKey,
    keys,
    addKeyToList,
    activeField,
    activeScreen,
    vin,
    data,
    AddDeviceForm,
    onChange,
    onFocusKeys,
    onFocusVin,
    onPair,
    onAddDevice,
    parentNetworkId,
    device,
    actions,
    titleVariant,
    onClose,
    deviceId,
    disablePairing
  } = props;
  const blueprintType = activeField === 'keys' ? 'Key' : 'Vehicle';
  const blueprintName = activeField === 'keys' ? 'key' : 'vehicle';
  const createBlueprintName = activeField === 'keys' ? t('createKey') : t('createVehicle');
  let deviceData;
  if (activeField === 'vin') {
    deviceData = {
      networkAliases: {
        [parentNetworkId]: {
          deviceId: device?.id
        }
      },
      data: {
        vin
      }
    };
  } else if (activeField === 'keys') {
    deviceData = {
      data: {
        keyId: keys[data.index]?.keyId
      }
    };
  }
  let header, content, footer;
  let body = null;
  // controls showing different types of components based on active screen state
  switch (activeScreen) {
    case 'add':
      body = /*#__PURE__*/_jsx(AddDeviceForm, {
        blueprintType: blueprintType,
        createBlueprintName: createBlueprintName,
        actions: actions,
        index: data.index,
        target: {
          type: `${blueprintName}`,
          data: deviceData
        },
        onSubmit: onAddDevice,
        onCancel: () => {
          onChange({
            data: {
              field: activeField,
              index: data.index,
              keyId: null
            },
            value: null
          });
        }
      });
      break;
    case 'scan':
      body = /*#__PURE__*/_jsx(Scan, {
        ...props,
        eventData: activeField,
        onClick: onClick,
        onChange: onChange
      });
      break;
    case 'search':
      {
        body = /*#__PURE__*/_jsx(DeviceSearch, {
          ...props,
          eventData: activeField,
          index: data?.index,
          value: activeField === 'vin' ? vin : keys[data.index]?.keyId,
          onChange: onChange,
          onClick: onClick,
          deviceId: deviceId
        });
        break;
      }
    default:
      header = /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(TitleBar, {
          variant: titleVariant,
          title: t('title'),
          icon: tIcon('titleIcon')
        }), /*#__PURE__*/_jsx(Button, {
          variant: "closeDialog",
          className: S.close,
          onClick: onClose
        })]
      });
      content = /*#__PURE__*/_jsxs(Flex, {
        variant: "colL",
        children: [/*#__PURE__*/_jsx(Text, {
          className: S.body,
          children: t('pairingMessage')
        }), /*#__PURE__*/_jsx(Text, {
          variant: "tooltip",
          children: t('tipMessage')
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "colS",
          children: [/*#__PURE__*/_jsx(Label, {
            variant: "inputTitle",
            children: t('selectVehicle')
          }), /*#__PURE__*/_jsx(DeviceInput, {
            "data-test-postfix": "VIN",
            hint: t('searchVehicle'),
            eventData: "vin",
            value: vin,
            onChange: onChange,
            onFocus: onFocusVin,
            onClick: onClick
          })]
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "colS",
          children: [/*#__PURE__*/_jsx(Label, {
            variant: "inputTitle",
            children: t('selectKey')
          }), /*#__PURE__*/_jsx(Flex, {
            variant: "colM",
            children: keys.map((key, index) =>
            /*#__PURE__*/
            // eslint-disable-next-line react/no-array-index-key
            _jsxs(Flex, {
              variant: "rowL",
              children: [/*#__PURE__*/_jsx(DeviceInput, {
                "data-test-postfix": "Key",
                hint: t('searchKey'),
                eventData: "keys",
                index: index,
                value: key.keyId,
                onChange: onChange,
                onFocus: onFocusKeys,
                onClick: onClick
              }), /*#__PURE__*/_jsx(Button, {
                className: keys.length === 1 ? S.disabled : '',
                variant: "itemBar",
                icon: tIcon('trashIcon'),
                onClick: () => onDeleteKey(index),
                disabled: keys.length === 1
              })]
            }, `${key.keyId}_${index}`))
          })]
        }), /*#__PURE__*/_jsx(Flex, {
          className: S.buttonWrap,
          children: /*#__PURE__*/_jsx(Button, {
            icon: tIcon('plusCircleIcon'),
            variant: "secondary",
            onClick: addKeyToList,
            children: t('pairAnotherKey')
          })
        })]
      });
      footer = /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: onClose,
          variant: "secondary",
          children: t('cancel')
        }), /*#__PURE__*/_jsx(Button, {
          "data-test-id": "button.pairing.pair",
          variant: "primary",
          disabled: disablePairing,
          onClick: onPair,
          children: t('pair')
        })]
      });
  }
  return /*#__PURE__*/_jsxs(Content, {
    relative: true,
    children: [header && /*#__PURE__*/_jsx(Content.Header, {
      variant: "itemFormHeader|formHeader",
      className: S.header,
      children: header
    }), content && /*#__PURE__*/_jsx(Content.Area, {
      variant: "itemFormBody|formBody",
      className: S.form,
      children: content
    }), footer && /*#__PURE__*/_jsx(Content.Footer, {
      variant: "formButtons",
      layout: "flex:rowMEnd",
      children: footer
    }), body]
  });
}